import { render } from "./EventList.vue?vue&type=template&id=adfe9d38&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=adfe9d38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-adfe9d38"

export default script